/**
{%- comment -%} Custom select element {%- endcomment -%}
{%- assign pets = 'dog,cat,hamster,parrot,spider,goldfish' | split: ',' -%}
<p class="field__label">Custom select dropdown</p>
<enhanced-select>
  <select name="pets" class="field__select js:hidden" data-select>
    <option value="">Select your option</option>
    {%- for pet in pets -%}
      <option value="{{ pet }}">
        {{- pet | camelize -}}
      </option>
    {%- endfor -%}
  </select>
  <div class="relative no-js:hidden">
    <button type="button" class="field__input pr-12 text-left" data-button>
      <span data-current> Select your option </span>
      {%- render 'global-icon',
        icon: 'chevron-down',
        icon_class: 'w-5 absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none'
      -%}
    </button>
    <div
      class="
        absolute left-0
        top-0 hidden w-full rounded border border-black-100 bg-white p-2 shadow-md
      "
      data-dropdown
    >
      {%- for pet in pets -%}
        <div
          class="dropdown-picker__item max-h-[20rem] cursor-pointer overflow-y-auto rounded px-3 py-1 hover:bg-black-100 active:bg-black-300"
          data-dropdown-option="{{ pet }}"
        >
          {{ pet | camelize }}
        </div>
      {%- endfor -%}
    </div>
  </div>
</enhanced-select>
 */

(async () => {
  const { computePosition, flip, autoUpdate, shift } = await import('@floating-ui/dom');

  if (!customElements.get('enhanced-select')) {
    class EnhancedSelect extends HTMLElement {
      constructor() {
        super();
        // Basic elements
        this.select = this.querySelector('select[data-select]');
        this.button = this.querySelector('[data-button]');
        this.current = this.querySelector('[data-current]');
        this.dropdown = this.querySelector('[data-dropdown]');
        this.dropdownOptions = this.dropdown.querySelectorAll('[data-dropdown-option]');
        this.open = false;
        this.cleanup = () => {};
        this.blockDispatch = false || this.hasAttribute('data-block-dispatch');

        this.button.addEventListener('click', () => {
          this.open = !this.open;
          this.cleanup = autoUpdate(this.button, this.dropdown, this.updatePosition.bind(this));
          this.open ? this.showDropdown() : this.hideDropdown();
        });

        this.dropdownOptions.forEach((option) => {
          option.addEventListener('click', () => {
            this.handleOptionSelect(option);
          });
        });
      }

      /**
       * handleClickOutside
       * @param {Object} event
       */
      handleClickOutside = (event) => {
        if (!this.contains(event.target)) {
          this.hideDropdown();
        }
      };

      /**
       * updatePosition
       */
      updatePosition() {
        computePosition(this.button, this.dropdown, {
          placement: 'bottom',
          middleware: [flip(), shift()],
        }).then(({ x, y }) => {
          Object.assign(this.dropdown.style, {
            left: `${x}px`,
            top: `${y}px`,
          });
        });
      }

      /**
       * showDropdown
       */
      showDropdown() {
        this.classList.add('open');
        this.dropdown.classList.remove('hidden');
        document.addEventListener('click', this.handleClickOutside);
      }

      /**
       * hideDropdown
       */
      hideDropdown() {
        this.classList.remove('open');
        this.open = false;
        this.dropdown.classList.add('hidden');
        this.cleanup();
        document.removeEventListener('click', this.handleClickOutside);
      }

      /**
       * handleOptionSelect
       * @param {Node} currentOption
       */
      handleOptionSelect(currentOption) {
        this.dropdownOptions.forEach((item) => {
          if (item.dataset.dropdownOption != currentOption.dataset.dropdownOption) {
            item.classList.remove('bg-black-100');
            this.current.innerHTML = currentOption.innerHTML;
          } else {
            item.classList.add('bg-black-100');
          }
        });

        this.hideDropdown();

        if (this.select) {
          this.select.value = currentOption.dataset.dropdownOption;
          // Block dispatch for when you do not want to trigger the original select
          if (this.blockDispatch) return;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    customElements.define('enhanced-select', EnhancedSelect);
  }
})();
